// extracted by mini-css-extract-plugin
export default {"container":"style_container__SOBR7","notSupported":"style_notSupported__Jp8FI","text":"style_text__RUq-k","link":"style_link__BNR8D","sendButton":"style_sendButton__YD-Ex"};